<template>
  <div class="">
    <img class="relative w-full object-fill" src="@/assets/images/lumia.svg" />
  </div>
</template>

<script lang="ts" setup></script>
